import React, { forwardRef } from 'react'
import styles from './Html.module.sass'
import clsx from 'clsx'

interface Props {
    className?: string,
    html?: string | null,
    truncate?: boolean,
}

const Html = forwardRef<HTMLDivElement, Props>((props, ref) => <div
    ref={ref}
    className={clsx(props.className, styles.html, {[styles.truncate]: props.truncate})}
    onClick={event => event.stopPropagation()}
    dangerouslySetInnerHTML={{ __html: props.html ?? '' }}
/>)

Html.displayName = 'Html'

export default Html